import {
  Order_By,
  useMixArchiveMainExposedQuery,
  useMixArchiveTagsQuery,
} from "graphql/generated";

export const useMixArchives = () => {
  const {
    data: archiveData,
    loading: archiveLoading,
  } = useMixArchiveMainExposedQuery({
    variables: {
      limit: 8,
      orderBy: [{ created_at: Order_By.Desc }],
    },
  });

  const {
    data: archiveTagsData,
    loading: archiveTagsLoading,
  } = useMixArchiveTagsQuery();

  return {
    archives: archiveData?.mix_archive ?? [],
    archiveTagEnums: archiveTagsData?.mix_archive_tags ?? [],
    archivesLoading: archiveLoading || archiveTagsLoading,
  };
};

